/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'multiple-users': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8 4.5a2 2 0 114 0 2 2 0 01-4 0zm2-3a3 3 0 100 6 3 3 0 000-6zM6 12.833C6 11.23 7.19 10 8.577 10h2.846C12.809 10 14 11.23 14 12.833V17.5a.5.5 0 101 0v-4.667C15 10.755 13.435 9 11.423 9H8.577C6.564 9 5 10.755 5 12.833V17.5a.5.5 0 001 0v-4.667zM15 6.5a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0zm2.5 3a.5.5 0 100 1h.29c.68 0 1.21.534 1.21 1.167V16a.5.5 0 101 0v-3.333c0-1.209-1.002-2.167-2.21-2.167h-.29zM5 6.5a1 1 0 110 2 1 1 0 010-2zm2 1a2 2 0 10-4 0 2 2 0 004 0zm-2.5 3a.5.5 0 010 1h-.29c-.68 0-1.21.534-1.21 1.167V16a.5.5 0 01-1 0v-3.333C2 11.458 3.001 10.5 4.21 10.5h.29z" _fill="#1F222C"/>'
  }
})
